import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function AirwayView() {
  useDocumentTitle('Ventilation and airway management-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-24'}
        title={'Ventilation and Airway Management'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="color-border mb-3"></div>
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">
                The highest standards of complex clinical care in your home
              </h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">F</span>or individuals who
                  need assistance breathing at home, including adults, kids, and
                  teenagers, we offer ventilation and airway management care
                  services.
                </p>
                <p className="values_p3">
                  People with serious breathing issues, which are frequently
                  brought on by challenging medical conditions, can now receive
                  mechanical ventilation therapy at home.
                </p>
                <p className="values_p3">
                  Due to their clinical state, a client may occasionally have a
                  tracheostomy placed, and ventilation will be administered via
                  this method (known as invasive ventilation, or IV).
                  Non-Invasive Ventilation (NIV), also known as ventilation
                  through a facial or nasal mask, is another option.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with-us">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/how-we-deliver">
                        How we deliver our care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/testimonials">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80 ">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Creating your bespoke package of care
                </h2>
                <p className="white-color">
                  To facilitate your discharge from a hospital setting and
                  provide support for you in the comfort of your home, we
                  collaborate closely with acute settings, ventilation teams,
                  respiratory consultants, and therapists, including
                  occupational, physio, and speech therapists.
                </p>
                <p className="white-color">
                  To create customized, secure care services, we adhere to the
                  National Long-Term Ventilation (LTV) Standards and the
                  National Children's Framework.
                </p>
                <p className="white-color">
                  Each member of our care team completes a specialized internal
                  training program presented in accordance with best practice
                  recommendations. The course is taught by our nursing teams
                  with input from experts and combines theory and practical
                  learning using models to make sure that our care staff is
                  prepared for your specific equipment and individual
                  requirements.
                </p>
                <p className="white-color">
                  {' '}
                  Our care staff spend time shadowing and becoming completely
                  competent in all aspects of your care, whether they are
                  discharging you from the hospital or taking over from another
                  provider.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">The way we support you</h2>
                <p>
                  The types of specialist care we provide when you need
                  respiratory support at home include:
                </p>
                <div>
                  <ul className="care_bullets-2">
                    <li>
                      Tracheostomy management, including stoma care,
                      humidification, nebulizers, suction, changing tapes,
                      speaking valve, changing a tracheostomy tube, mouth care,
                      and inner tubes.
                    </li>
                    <li className="">Invasive Ventilation.</li>
                    <li>Non-Invasive Ventilation BIPAP & CPAP.</li>
                    <li>Cough assist.</li>
                    <li>
                      Hand ventilation or bag, valve, and mask/tracheostomy
                      ventilation.
                    </li>
                    <li>Chest physio.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">What a ventilator is</h2>
                <p className="white-color">
                  A medical ventilator is a device made to transport air into
                  and out of the lungs. It gives someone who is unable to
                  breathe on their own the ability to breathe.
                </p>
                <p className="white-color">
                  Ventilators can be used safely and indefinitely inside the
                  home.
                </p>
                <p className="white-color">
                  While some ventilators can fully take over the job of
                  breathing, others can help and support patients as they do so.
                </p>
                <p className="white-color">
                  Our employees have received thorough training in all facets of
                  ventilation control.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">What ventilation is</h2>
                <div>
                  <ul className="care_bullets-2">
                    <li>
                      Oxygen (O2) is breathed in (inspiration) and carbon
                      dioxide (CO2) is breathed out (expiration) during
                      breathing, also known as respiration.
                    </li>
                    <li>
                      With each inspiration, oxygen enters the lungs and is then
                      absorbed into the circulatory system reaching all of the
                      body's cells.The blood also carries carbon dioxide, a
                      waste product of cell activity, to the lungs, where it can
                      be expelled from the body during expiration.
                    </li>
                    <li>
                      The quantity of oxygen and carbon dioxide in the body is
                      balanced and controlled by breathing.
                    </li>
                    <li>
                      Some of our clients struggle to breathe properly due to a
                      variety of medical conditions such as weakness of the
                      respiratory muscles, spinal cord injuries or neurological
                      problems.
                    </li>
                    <li>
                      A specific device that provides ventilation, also known as
                      assisted ventilation or artificial ventilation helps the
                      patient breathe more easily. The mechanical device forces
                      air containing oxygen (O2) into the lungs during
                      inspiration and makes it easier to expel carbon dioxide
                      (CO2) during expiration.
                    </li>
                    <li>
                      Ventilatory support can aid in a client's growth and
                      activities.
                    </li>
                    <li>
                      Depending on the client's requirements, a ventilatory
                      assistance device may be used while the client is awake or
                      while they are sleeping to support or improve their
                      breathing and general health.
                    </li>
                    <li>
                      Depending on the sort of interface between the client and
                      the ventilatory assistance device, ventilatory assistance
                      is divided into two categories:
                    </li>
                    <li>
                      intrusive ventilation: where a tracheal cannula connects
                      the apparatus to the patient.
                    </li>
                    <li>
                      {' '}
                      Non-invasive ventilation is achieved by attaching the
                      device to a mouthpiece or a mask (nasal, facial, or nasal
                      cushions) with an incorporated exhalation valve.
                    </li>
                    <li>
                      If our client is unable to breathe properly on their own,
                      manual ventilation using a ventilatory bag (or manual
                      ventilatory bag, manual ventilatory device, bag valve
                      mask, self-inflating bag with a non-rebreathing valve, or
                      Ambu bag) may be required.
                    </li>
                    <li>
                      The following are some scenarios where physical
                      ventilation may be necessary:
                    </li>
                    <li>
                      To change the ventilatory circuit or ventilatory
                      assistance device.
                    </li>
                    <li>
                      To mobilize and improve clearance of secretions and/or
                      aspiration of secretions.
                    </li>
                    <li>
                      To replace a mechanical ventilatory assistance device
                      while it is disconnected for transportation or to
                      facilitate mobility (e.g., transferring our client from
                      chair to bed, repositioning, daily care such as bathing,
                      etc.).
                    </li>
                    <li>
                      To do cough assist techniques using a device, manually, or
                      a modified ventilatory bag.
                    </li>
                    <li>To ventilate during cardiopulmonary resuscitation</li>
                    <li>
                      {' '}
                      To ventilate in an emergency situation such as respiratory
                      distress, obstruction or accidental decannulation of the
                      tracheal cannula.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-volume-up"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="Read what our customers have to say about us.
        "
        link1="/team"
        link2="/testimonials"
        btn1="Meet our team"
        btn2="Read our testimonials"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default AirwayView;
